<dx-load-panel
    shadingColor="rgba(0,0,0,0.4)"
    [visible]="isLoading"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false">
</dx-load-panel>
<div id="floating-button-result" fxLayout="column" fxLayoutAlign="start center">
    <div class="content-block dx-card responsive-paddings ocl-top-container" style="width: 95vw">
        <div fxLayout="row" fxLayoutAlign="stretch" class="padding-block">
            <h3>Laboratory Results</h3>
        </div>
        <form [formGroup]="resultsSearchForm" (ngSubmit)="searchResults()">
            <div fxShow fxHide.gt-sm class="padding-block" fxLayout="row" fxLayoutAlign="start center">
                <div fxLayout="row" fxLayoutAlign="start" style="width: 500px">
                    <app-order-status-radio-buttons
                        [control]="convertToFormControl(resultsSearchForm.get('status'))"
                        [fromAlerts]="false"></app-order-status-radio-buttons>
                </div>
            </div>
            <div class="padding-block" fxLayout="row" fxLayoutAlign="space-between stretch">
                <div fxLayout="column" [ngStyle.xs]="{width: '100%'}" [ngStyle.sm]="{width: '60%'}">
                    <app-from-to-date-range-selector
                        [startGroupControl]="convertToFormControl(resultsSearchForm.get('startDate'))"
                        [endGroupControl]="convertToFormControl(resultsSearchForm.get('endDate'))">
                    </app-from-to-date-range-selector>
                </div>
                <app-client-selector fxShow fxHide.lt-md [ngStyle.md]="{width: '50%', 'padding-left': '20px' }"
                                     *ngIf="role !== 'Physician' && role !== 'Patient'" id="clientSelector"
                                     [clearBtn]="false"
                                     [control]="resultsSearchForm.get('client')"></app-client-selector>
                <app-selector
                    fxShow fxHide.lt-md [ngStyle.md]="{'padding-left': '20px' }"
                    *ngIf="role !== 'Physician' && role !== 'Patient'"
                    [items]="unitsDataSource.value"
                    [label]="'Unit'"
                    [remoteOperations]="true"
                    [control]="resultsSearchForm.get('unit')"
                    [displayExpr]="'name'"
                    [keyExpr]="'id'"
                    [required]="false">
                </app-selector>
                <app-patient-selector fxShow fxHide.lt-md [ngStyle.md]="{'padding-left': '20px' }"
                                      *ngIf="role !== 'Patient'"
                                      [control]="resultsSearchForm.get('patient')"></app-patient-selector>

                <div fxShow fxHide.lt-sm fxHide.gt-sm fxLayout="row" fxLayoutAlign="end end"
                     style="padding-left: 30px; padding-bottom: 5px">
                    <app-search-btn style="margin-right: 10px" [disabled]="!resultsSearchForm.valid"
                                    (click)="searchResults()"></app-search-btn>
                    <app-clear-all-btn (click)="clear()"></app-clear-all-btn>
                </div>
            </div>
            <div fxShow fxHide.sm class="padding-block" fxLayout="row" fxLayoutAlign="space-between center"
                 fxLayoutAlign.lt-md="end center">
                <div fxLayout="row" fxLayoutAlign="start" style="width: 600px" fxShow fxHide.lt-md>
                    <app-order-status-radio-buttons
                        [control]="convertToFormControl(resultsSearchForm.get('status'))"
                        [fromAlerts]="false"></app-order-status-radio-buttons>
                    <div class="dx-field" style="width: auto !important;" *ngIf="showMissingInfo">
                        <div class="dx-field-label"></div>
                        <div class="dx-field-value" style="width: auto !important; margin-top: 16px">
                            <dx-check-box [formControl]="convertToFormControl(resultsSearchForm.get('missingInfo'))"
                                          text="Missing Information"></dx-check-box>
                        </div>
                    </div>
                    <div class="dx-field" style="width: auto !important;">
                        <div class="dx-field-label"></div>
                        <div class="dx-field-value" style="width: auto !important; margin-left: 4px; margin-top: 16px">
                            <dx-check-box [formControl]="convertToFormControl(resultsSearchForm.get('criticalResults'))"
                                          text="Alert Results"></dx-check-box>
                        </div>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutAlign="end">
                    <app-search-btn style="margin-right: 5px" [disabled]="!resultsSearchForm.valid"
                                    (click)="searchResults()"></app-search-btn>
                    <app-clear-all-btn (click)="clear()"></app-clear-all-btn>
                </div>
            </div>
        </form>
    </div>
    <div class="content-block dx-card responsive-paddings ocl-bottom-container" style="width: 95vw !important;">
        <app-laboratory-results-content [filtersSubmitted]="formSubmitted"
                                        [showMissingInfo]="showMissingInfo"></app-laboratory-results-content>
    </div>
</div>
